import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function DealDirect() {
  const lynJonesPros = ['One accountable carrier from start to finish', "Fixed quote that doesn't change", 'No random bidders or brokers', 'Direct phone line to a real person', 'Fully insured heavy haul company'];
  const biddingCons = ['Your job auctioned to strangers', 'Prices often change after you commit', 'No single point of contact', 'Unknown or unvetted carriers', 'Hidden broker fees'];
  return <section className="py-20 bg-white" data-id="element-27">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-29">
          <h2 className="text-3xl md:text-4xl font-black text-brand-navy mb-4" data-id="element-30">
            Why Deal Direct vs a Bidding Site?
          </h2>
          <p className="text-lg text-slate-600" data-id="element-31">
            When you book with LynJones Logistics, you're hiring a dedicated,
            expert heavy equipment transport company. We provide one accountable
            point of contact from start to finish—no throwing your machinery to
            the lowest bidder.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-32">
          {/* LynJones Card */}
          <div className="bg-brand-navy text-white rounded-2xl p-8 shadow-2xl border-t-8 border-brand-red relative transform md:-translate-y-4" data-id="element-33">
            <div className="absolute -top-4 right-8 bg-brand-red text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-34">
              The Better Way
            </div>
            <h3 className="text-2xl font-black mb-6 flex items-center gap-3" data-id="element-35">
              <img src="https://lynjoneslogistics.com/wp-content/uploads/lynjones-logistics-Final.png" alt="LynJones" className="h-8 w-auto bg-white rounded p-1" data-id="element-36" />
              LynJones Logistics
            </h3>
            <ul className="space-y-4" data-id="element-37">
              {lynJonesPros.map((pro, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-38">
                  <CheckCircle2 className="w-6 h-6 text-green-400 shrink-0" data-id="element-39" />
                  <span className="text-lg font-medium" data-id="element-40">{pro}</span>
                </li>)}
            </ul>
          </div>

          {/* Bidding Sites Card */}
          <div className="bg-slate-50 border border-slate-200 rounded-2xl p-8 shadow-sm" data-id="element-41">
            <h3 className="text-2xl font-bold text-slate-500 mb-6" data-id="element-42">
              Bidding Marketplaces
            </h3>
            <ul className="space-y-4" data-id="element-43">
              {biddingCons.map((con, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-44">
                  <XCircle className="w-6 h-6 text-slate-400 shrink-0" data-id="element-45" />
                  <span className="text-lg text-slate-600" data-id="element-46">{con}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}